export enum UIA_THEME {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  WARNING = 'warning',
  SUCCESS = 'success',
  DANGER = 'danger',
  INFO = 'info',
  LIGHT = 'light',
  DARK = 'dark'
}
